import { FormValueDto } from './form-value.dto';

export class AntragMetaDataDto {
  public formResults: FormResults[];

  constructor(formResults: FormResults[]) {
    this.formResults = formResults;
  }
}

interface FormResults {
  templateName: string;
  formId: string;
  createdAt: Date;
  isValid: boolean;
  isMandatory: boolean;
  results: FormValueDto[];
}
